{
  "countries": {
    "AF": "Afghanistan",
    "AX": "Ålandinseln",
    "AL": "Albanien",
    "DZ": "Algerien",
    "AS": "Amerikanisch-Samoa",
    "AD": "Andorra",
    "AO": "Angola",
    "AI": "Anguilla",
    "AQ": "Antarktis",
    "AG": "Antigua und Barbuda",
    "AR": "Argentinien",
    "AM": "Armenien",
    "AW": "Aruba",
    "AC": "Ascension",
    "AU": "Australien",
    "AT": "Österreich",
    "AZ": "Aserbaidschan",
    "BS": "Bahamas",
    "BH": "Bahrain",
    "BD": "Bangladesch",
    "BB": "Barbados",
    "BY": "Belarus",
    "BE": "Belgien",
    "BZ": "Belize",
    "BJ": "Benin",
    "BM": "Bermuda",
    "BT": "Bhutan",
    "BO": "Bolivien",
    "BA": "Bosnien und Herzegowina",
    "BW": "Botsuana",
    "BR": "Brasilien",
    "IO": "Britisches Territorium im Indischen Ozean",
    "VG": "Britische Jungferninseln",
    "BN": "Brunei Darussalam",
    "BG": "Bulgarien",
    "BF": "Burkina Faso",
    "BI": "Burundi",
    "KH": "Kambodscha",
    "CM": "Kamerun",
    "CA": "Kanada",
    "IC": "Kanarische Inseln",
    "CV": "Kap Verde",
    "BQ": "Karibische Niederlande",
    "KY": "Kaimaninseln",
    "CF": "Zentralafrikanische Republik",
    "EA": "Ceuta und Melilla",
    "TD": "Tschad",
    "CL": "Chile",
    "CN": "China",
    "CX": "Weihnachtsinsel",
    "CC": "Kokosinseln",
    "CO": "Kolumbien",
    "KM": "Komoren",
    "CG": "Kongo-Brazzaville",
    "CD": "Kongo-Kinshasa",
    "CK": "Cookinseln",
    "CR": "Costa Rica",
    "CI": "Côte d’Ivoire",
    "HR": "Kroatien",
    "CU": "Kuba",
    "CW": "Curaçao",
    "CY": "Zypern",
    "CZ": "Tschechien",
    "DK": "Dänemark",
    "DG": "Diego Garcia",
    "DJ": "Dschibuti",
    "DM": "Dominica",
    "DO": "Dominikanische Republik",
    "EC": "Ecuador",
    "EG": "Ägypten",
    "SV": "El Salvador",
    "GQ": "Äquatorialguinea",
    "ER": "Eritrea",
    "EE": "Estland",
    "SZ": "Eswatini",
    "ET": "Äthiopien",
    "FK": "Falklandinseln",
    "FO": "Färöer",
    "FJ": "Fidschi",
    "FI": "Finnland",
    "FR": "Frankreich",
    "GF": "Französisch-Guayana",
    "PF": "Französisch-Polynesien",
    "TF": "Französische Süd- und Antarktisgebiete",
    "GA": "Gabun",
    "GM": "Gambia",
    "GE": "Georgien",
    "DE": "Deutschland",
    "GH": "Ghana",
    "GI": "Gibraltar",
    "GR": "Griechenland",
    "GL": "Grönland",
    "GD": "Grenada",
    "GP": "Guadeloupe",
    "GU": "Guam",
    "GT": "Guatemala",
    "GG": "Guernsey",
    "GN": "Guinea",
    "GW": "Guinea-Bissau",
    "GY": "Guyana",
    "HT": "Haiti",
    "HN": "Honduras",
    "HK": "Sonderverwaltungsregion Hongkong",
    "HU": "Ungarn",
    "IS": "Island",
    "IN": "Indien",
    "ID": "Indonesien",
    "IR": "Iran",
    "IQ": "Irak",
    "IE": "Irland",
    "IM": "Isle of Man",
    "IL": "Israel",
    "IT": "Italien",
    "JM": "Jamaika",
    "JP": "Japan",
    "JE": "Jersey",
    "JO": "Jordanien",
    "KZ": "Kasachstan",
    "KE": "Kenia",
    "KI": "Kiribati",
    "XK": "Kosovo",
    "KW": "Kuwait",
    "KG": "Kirgisistan",
    "LA": "Laos",
    "LV": "Lettland",
    "LB": "Libanon",
    "LS": "Lesotho",
    "LR": "Liberia",
    "LY": "Libyen",
    "LI": "Liechtenstein",
    "LT": "Litauen",
    "LU": "Luxemburg",
    "MO": "Sonderverwaltungsregion Macau",
    "MG": "Madagaskar",
    "MW": "Malawi",
    "MY": "Malaysia",
    "MV": "Malediven",
    "ML": "Mali",
    "MT": "Malta",
    "MH": "Marshallinseln",
    "MQ": "Martinique",
    "MR": "Mauretanien",
    "MU": "Mauritius",
    "YT": "Mayotte",
    "MX": "Mexiko",
    "FM": "Mikronesien",
    "MD": "Moldau",
    "MC": "Monaco",
    "MN": "Mongolei",
    "ME": "Montenegro",
    "MS": "Montserrat",
    "MA": "Marokko",
    "MZ": "Mosambik",
    "MM": "Myanmar",
    "NA": "Namibia",
    "NR": "Nauru",
    "NP": "Nepal",
    "NL": "Niederlande",
    "NC": "Neukaledonien",
    "NZ": "Neuseeland",
    "NI": "Nicaragua",
    "NE": "Niger",
    "NG": "Nigeria",
    "NU": "Niue",
    "NF": "Norfolkinsel",
    "KP": "Nordkorea",
    "MK": "Nordmazedonien",
    "MP": "Nördliche Marianen",
    "NO": "Norwegen",
    "OM": "Oman",
    "PK": "Pakistan",
    "PW": "Palau",
    "PS": "Palästinensische Autonomiegebiete",
    "PA": "Panama",
    "PG": "Papua-Neuguinea",
    "PY": "Paraguay",
    "PE": "Peru",
    "PH": "Philippinen",
    "PN": "Pitcairninseln",
    "PL": "Polen",
    "PT": "Portugal",
    "XA": "Pseudo-Accents",
    "XB": "Pseudo-Bidi",
    "PR": "Puerto Rico",
    "QA": "Katar",
    "RE": "Réunion",
    "RO": "Rumänien",
    "RU": "Russland",
    "RW": "Ruanda",
    "WS": "Samoa",
    "SM": "San Marino",
    "ST": "São Tomé und Príncipe",
    "SA": "Saudi-Arabien",
    "SN": "Senegal",
    "RS": "Serbien",
    "SC": "Seychellen",
    "SL": "Sierra Leone",
    "SG": "Singapur",
    "SX": "Sint Maarten",
    "SK": "Slowakei",
    "SI": "Slowenien",
    "SB": "Salomonen",
    "SO": "Somalia",
    "ZA": "Südafrika",
    "GS": "Südgeorgien und die Südlichen Sandwichinseln",
    "KR": "Südkorea",
    "SS": "Südsudan",
    "ES": "Spanien",
    "LK": "Sri Lanka",
    "BL": "St. Barthélemy",
    "SH": "St. Helena",
    "KN": "St. Kitts und Nevis",
    "LC": "St. Lucia",
    "MF": "St. Martin",
    "PM": "St. Pierre und Miquelon",
    "VC": "St. Vincent und die Grenadinen",
    "SD": "Sudan",
    "SR": "Suriname",
    "SJ": "Spitzbergen und Jan Mayen",
    "SE": "Schweden",
    "CH": "Schweiz",
    "SY": "Syrien",
    "TW": "Taiwan",
    "TJ": "Tadschikistan",
    "TZ": "Tansania",
    "TH": "Thailand",
    "TL": "Timor-Leste",
    "TG": "Togo",
    "TK": "Tokelau",
    "TO": "Tonga",
    "TT": "Trinidad und Tobago",
    "TA": "Tristan da Cunha",
    "TN": "Tunesien",
    "TR": "Türkei",
    "TM": "Turkmenistan",
    "TC": "Turks- und Caicosinseln",
    "TV": "Tuvalu",
    "UG": "Uganda",
    "UA": "Ukraine",
    "AE": "Vereinigte Arabische Emirate",
    "GB": "Vereinigtes Königreich",
    "US": "Vereinigte Staaten",
    "UY": "Uruguay",
    "UM": "Amerikanische Überseeinseln",
    "VI": "Amerikanische Jungferninseln",
    "UZ": "Usbekistan",
    "VU": "Vanuatu",
    "VA": "Vatikanstadt",
    "VE": "Venezuela",
    "VN": "Vietnam",
    "WF": "Wallis und Futuna",
    "EH": "Westsahara",
    "YE": "Jemen",
    "ZM": "Sambia",
    "ZW": "Simbabwe"
  }
}
